import React, { useState } from 'react'
import UIBody from '../../../components/ui/UIBody'
import CategoriesSection from './CategoriesSection'
import AboutSection from './AboutSection'
import KeyBenifits from './KeyBenifits'
import BrandArea from './BrandArea'
import FactArea from './FactArea'
import Testimonal from './Testimonal'
import HeroSection from './HeroSection'
import ContactUsSlider from '../../../components/Common/ContactUsSlider'
import OurServicesSection from './OurServicesSection'
import HomeSlider from './HomeSlider'
import HomeServices from './HomeServices'
import ServiceSection from './ServiceSection'
import WhyChooseUs from './WhyChooseUs'

const Home = () => {
 
  return (
    <UIBody
      content={
        <div>
         <HomeSlider/>
      
           {/* <section class="features__area-seven grey-bg-two">
            <div class="container">
                <div class="features__item-wrap-four">
                    <div class="row">
                        <div class="col-xl-3 col-lg-4 col-md-6">
                            <div class="features__item-six">
                                <div class="features__icon-six">
                                    <i class="skillgro-profit"></i>
                                </div>
                                <div class="features__content-six">
                                    <h4 class="title">Learn skills with 120k+</h4>
                                    <span>video courses.</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-4 col-md-6">
                            <div class="features__item-six">
                                <div class="features__icon-six">
                                    <i class="skillgro-instructor"></i>
                                </div>
                                <div class="features__content-six">
                                    <h4 class="title">Choose courses</h4>
                                    <span>real-world experts.</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-4 col-md-6">
                            <div class="features__item-six">
                                <div class="features__icon-six">
                                    <i class="skillgro-tutorial"></i>
                                </div>
                                <div class="features__content-six">
                                    <h4 class="title">processional Tutors</h4>
                                    <span>video courses.</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-4 col-md-6">
                            <div class="features__item-six">
                                <div class="features__icon-six">
                                    <i class="skillgro-graduated"></i>
                                </div>
                                <div class="features__content-six">
                                    <h4 class="title">Online Degrees</h4>
                                    <span>Study flexibly online</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section> */}
             {/* <OurServicesSection/>  */}
   {/* <HomeServices/> */}
   <ServiceSection/>
      
      
          {/* <CategoriesSection /> */}
          <WhyChooseUs/>
          <Testimonal/>
      
          {/* <AboutSection /> */}
         
          {/* <Testimonal /> */}
          <KeyBenifits />
          <BrandArea />
          <FactArea />
          <br />
        </div>
      }
    />
  )
}

export default Home